import classNames from 'classnames';
import React, { FC } from 'react';

import { tabItemBorderLeftSvg, tabItemBorderRightSvg } from '../assets/images';

export interface TabItemProps {
  title: string;
  position: 'left' | 'center' | 'right';
  active?: boolean;
  href?: string;
}

const TabItem: FC<TabItemProps> = (props) => {
  return (
    <a href={props.href}>
      <div
        className={classNames(
          'oejr-tab-item',
          `oejr-tab-item-${props.position}`,
          props.active && `oejr-tab-item-active`,
        )}
      >
        <div className="active-left-border">
          <img src={tabItemBorderLeftSvg} alt="Tab Item Border" />
        </div>
        <div className="oejr-tab-item-text-wrapper">
          <h3>{props.title}</h3>
        </div>
        <div className="active-right-border">
          <img src={tabItemBorderRightSvg} alt="Tab Item Border" />
        </div>
      </div>
    </a>
  );
};

export default TabItem;
